import { filterSystemTypesList } from 'common/api/v1/core';

import {
    FETCH_SYSTEM_TYPES,
    FETCH_SYSTEM_TYPES_FAILURE,
    FETCH_SYSTEM_TYPES_SUCCESS,
} from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default (type) => (dispatch) => {
    dispatch(createProposalModalActions[FETCH_SYSTEM_TYPES]());

    filterSystemTypesList(type)
        .then((response) =>
            dispatch(
                createProposalModalActions[FETCH_SYSTEM_TYPES_SUCCESS](
                    response?.data?.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                createProposalModalActions[FETCH_SYSTEM_TYPES_FAILURE](error),
            ),
        );
};
